// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1umbX8c1McmViADf811_ey","icon":"_30Qwjgvq1HXaZjQaGJfgX0"};